import React, { Component } from 'react';
import moment from 'moment';
import {BeatLoader} from 'react-spinners';
import { get } from '../../../../../server/actions';
import ReactTable from 'react-table';
import CalenderCarousel from '../CalenderCarousel/CalenderCarousel';
import NotificationSystem from 'react-notification-system';
import { _addNotificationError, getGradeNumberByText, groupBy } from '../../../../../server/util'
import { showFile } from "../../../../../server/util";
import PrintLabels from '../../printLabels';
//import { debugger } from 'fusioncharts';
class SnackOrderReport extends Component {
    constructor(props) {
        super();
        this.state = {
            showDashboard: true,
            showBy: 'Daily',
            dayGrade: 'All',
            weekGrade: 'All',
            orderStudentWithMealWeek: [],
            orderStudentWithMealDay: [],
            mealsByGradeAndDate: {},
            orderResponse: '',
            orderResponseWeek:'',
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            wStartDate: moment().startOf('week'),
            wEndDate:moment().endOf('week'),   
            date: moment(),
            loading:false,
            pdfDayStartDate: moment().startOf('day'),
            pdfDayEndDate: moment().endOf('day'),
            pdfWeekStartDate: moment().startOf('week'),
            pdfWeekEndDate: moment().endOf('week'),
        };
    }
    componentWillMount = () => {
        //this.getSchoolMealReport();
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.setDay();
        this.setWeek();
    }
    setDay = () => {
        this.setState({
            date: moment(),
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            toogle: !this.state.toogle,
        }, () => {
            this.getSchoolMealReport(moment().startOf('day'), moment().endOf('day'), 'Day');
        });
    }
    setWeek = () => {
        const from_date = moment().startOf('Week');
        const to_date = moment().endOf('Week');
        this.setState({
            week: from_date.format('MM/DD') + " - " + to_date.format('MM/DD'),
            date: from_date,
            wStartDate: from_date,
            wEndDate: to_date,
            toogle: !this.state.toogle,
        }, () => {
            this.getSchoolMealReport(from_date, to_date, 'week');
        });
    }
    getSchoolMealReport = (startDate, endDate, type) => {
        this.setState({loading: true});
        get(`/reports/schoolMealReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if (type === 'week') {
                this.setState({ orderStudentWithMealWeek: data.studentWithMeal, orderResponseWeek: data.startDate,loading:false })
            }
            else {
                this.setState({ orderStudentWithMealDay: data.studentWithMeal, orderResponse: data.startDate, mealsByGradeAndDate: data.mealsByGradeAndDate, loading:false })
            }
        }).catch(error => {
            this.setState({loading: false});
            console.log("Loading Report Failed", error)
        })
    }
    getSchoolMealReportPdf = (startDate, endDate,type) => {
        const { dayGrade,weekGrade } = this.state;
        this.setState({loading: true});
        let url = '';
        if(type === 'Day'){
            if(dayGrade === 'All'){
                url=`/reports/schoolExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
            }
            else{
                url=`/reports/schoolExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${dayGrade}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
            }
        }
        else{
            if(weekGrade === 'All'){
                url=`/reports/schoolExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
            }
            else{
                url=`/reports/schoolExportReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&grades=${weekGrade}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&fileType=Pdf&access_token=`
            }
        }
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({loading: false});
            return response.blob();
        }).then(blob => {
            let filename = "Orders Reports for ";
            showFile(blob, filename);
        }).catch(error => {
            this.setState({loading: false});
            console.log("Download Failed", error)
        })
    }
   /*  setDayPdf = () => {
        this.setState({
            date: moment(),
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            toogle: !this.state.toogle,
        }, () => {
            this.getSchoolMealReportPdf(moment().startOf('day'), moment().endOf('day'),'Day');
        });
    } */
    setDayPdf = () => {
        const from_date =this.state.pdfDayStartDate;
        const to_date =this.state.pdfDayEndDate;
        this.getSchoolMealReportPdf(from_date, to_date,'Day');
    }
    setWeekPdf = () => {
        const from_date = this.state.pdfWeekStartDate;
        const to_date = this.state.pdfWeekEndDate;
        this.getSchoolMealReportPdf(from_date, to_date,'week');
    }
    /* setWeekPdf = () => {
        const from_date = moment().startOf('Week');
        const to_date = moment().endOf('Week');
        this.setState({
            week: from_date.format('MM/DD') + " - " + to_date.format('MM/DD'),
            date: from_date,
            startDate: from_date,
            endDate: to_date,
            toogle: !this.state.toogle,
        }, () => {
            this.getSchoolMealReportPdf(from_date, to_date,'week');
        });
    } */
    /* getSchoolMealReportByGrades = (startDate, endDate) => {        
        get(`/reports/schoolMealReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&grades=${grade}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
           this.setState({orderStudentWithMeal:data.studentWithMeal})
        }).catch(error => {
            console.log("Loading Report Failed", error)
        })
    } */
    getTableData(data) {
        let resArr = [];
        data.forEach(function (item) {
            let i = resArr.findIndex(x => x.grade == item.grade);
            if (i <= -1) {
                resArr.push({ grade: item.grade, total: data.filter(x => x.grade === item.grade).length });
            }
        });
        return resArr;
    }
    bindWeekDataTable = () => {
        const { orderResponseWeek, orderStudentWithMealWeek } = this.state;
        let items = [];
        const cols = [{ Header: "Student", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
        {
            Header: "Grade",style: { textAlign: 'center', textTransform:'capitalize' }, Cell: (props) => {
                return <span >{getGradeNumberByText(props.original.grade)}</span>
            }
        },
        { Header: "Teacher", accessor: "teacherName" },
        { Header: "Allergy", Cell: props => <span>{(props.original.allergies || '') === '' ? 'No Allergies' : props.original.allergies}</span> }];
        for (let i = 1; i < 6; i++) {
            cols.push({
                Header: moment(moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD').format('MM/DD'),
                accessor: moment(orderResponseWeek).add(i, 'days').format('YYYY-MM-DD'), width: 150, style: { textAlign: 'center' }
            });
            moment(this.state.date).subtract(1, 'days');
        }
        const finalArray = []
        orderStudentWithMealWeek.map((itm, index) => {
            const itemObj = orderStudentWithMealWeek[index];
            Object.keys(itm.mealOrderedByDate).map((key, i) => {
                itemObj[key] = (itm.mealOrderedByDate[key] || '').toString();
            });
            finalArray.push(itemObj);
        })
        return <ReactTable
            data={(this.state.weekGrade === "All") ? finalArray : finalArray.filter(item => item.grade === this.state.weekGrade)}
            columns={cols}
            defaultPageSize={10}
            className="-striped -highlight"
            noDataText='No data found' />
    }
    /* bindDayDataTable=()=>{
        const {orderResponse, orderStudentWithMeal}=this.state;
        let items=[];
        const cols=[{ Header: "Student",accessor: "studentFName",Cell: props => <span>{props.original.studentLName+' '+props.original.studentFName}</span> },
        { Header: "Grade", Cell:(props)=>{
            return <span>{getGradeNumberByText(props.original.grade)}</span>        
        }, },
        { Header: "Teacher",accessor: "teacherName" },
        { Header: "Items Name"},
        { Header: "Sides" },
        { Header: "Allergies",accessor: "allergies" },
        { Header: "Served", accessor: "served" }]
          const finalArray=[]      
        orderStudentWithMeal.map((itm,index)=>{
            const itemObj=orderStudentWithMeal[index];
            Object.keys(itm.mealOrderedByDate).map((key,i)=>{
                itemObj[key]= (itm.mealOrderedByDate[key]||'').toString();
            });
            finalArray.push(itemObj);
        }) 
        return <ReactTable
        data={(this.state.grade==="All")?finalArray:finalArray.filter(item => item.grade===this.state.grade)}
        columns={cols}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText='No data found' />
    } */
    getSidesVal = (props) => {
        const { mealsByGradeAndDate, orderResponse } = this.state;
        let _val = '';
        Object.keys(mealsByGradeAndDate).map((val, key) => {
            if (props.original.grade === val) {
                _val = (mealsByGradeAndDate[val][moment(orderResponse).format('YYYY-MM-DD')] || '').toString();
            }
        })
        return _val;
    }
    getTotalOrderItemsByWeek=(list)=>{
        let count=0;
        list.forEach(item=>{
            Object.keys(item.mealOrderedByDate||{}).forEach(x=>{
                count=count+ ((item.mealOrderedByDate||{})[x]||[]).length;
            })
        });
        return count
    }
    bindOrderCountByGradeInWeek=(list)=>{
        // { grade: item.grade, total: data.filter(x => x.grade === item.grade).length }
        const _groupByGrades=groupBy(list,'grade');
       let finalList= Object.keys(_groupByGrades).map(gr=>{
           let count=0;
           (_groupByGrades[gr]||[]).map(itm=>{
               count=count+Object.keys(itm.mealOrderedByDate||{}).length;               
           })

           return {grade:gr,total:count}
        });
        return finalList||[];
    }
    render() {
        let { showDashboard, showBy, grade, date, startDate, endDate, wStartDate,wEndDate } = this.state;
        const self=this;
        console.log('orders', this.state);
        return (
            <div>
            <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                </div>
                {showDashboard ? 
                <div className="panel panel-p1 panel-primary">
                <div className="panel-heading text-center">
                    <h3 className="panel-title">Orders</h3>
                </div>
                <div className="row">
                    <div className="col-sm-6 col-xs-6" style={{ textAlign: 'center', padding: '20px' }}>
                        <div style={{ textAlign: '-webkit-center' }}>
                            <div className="orders-report-counter" style={{ backgroundColor: '#b5d56a' }} onClick={() => {
                                this.setState({ showBy: 'Daily', showDashboard: false }, () => {
                                    this.setDay();
                                })
                            }}>
                                <p className="orders-report-counter-title"> Current Day</p>
                                <p className="orders-report-counter-title"> Snack Orders Total</p>
                                <p className="orders-report-counter-value">{this.state.orderStudentWithMealDay.length || 0}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: '-webkit-center' }}>
                            <div style={{ display: "table", padding: '10px' }}>
                                <ReactTable
                                    data={this.getTableData((this.state.orderStudentWithMealDay).sort(function(a,b) {return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0);}).sort(function(x,y){ return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }) )}
                                    columns={[{
                                        Header: "Grade", Cell: (props) => {
                                            return <span >{getGradeNumberByText(props.original.grade)}</span>
                                        }
                                    },
                                    { Header: "Total Orders", width: 150, accessor: "total" }]}
                                    defaultPageSize={10}
                                    className="-striped -highlight rtTable-Order"
                                    noDataText='No data found'
                                    showPagination={false}
                                />
                            </div>
                        </div>                        
                    </div>
                    <div className="col-sm-6 col-xs-6" style={{ textAlign: 'center', padding: '20px' }}>
                        
                        <div style={{ textAlign: '-webkit-center' }}>
                            <div className="orders-report-counter" style={{ backgroundColor: '#f0ad4e' }} onClick={() => {
                                this.setState({ showBy: 'Weekly', showDashboard: false }, () => {
                                    this.setWeek();
                                })
                            }}>
                            <p className="orders-report-counter-title"> Current Week</p>
                            <p className="orders-report-counter-title">Snack Orders Total</p>
                            <p className="orders-report-counter-value">{this.getTotalOrderItemsByWeek(this.state.orderStudentWithMealWeek||[])}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: '-webkit-center' }}>
                            <div style={{ display: "table", padding: '10px' }}>
                                <ReactTable
                                    data={this.bindOrderCountByGradeInWeek((this.state.orderStudentWithMealWeek).sort(function(a,b) {return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0);}).sort(function(x,y){ return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }) )}
                                    columns={[{
                                        Header: "Grade", Cell: (props) => {
                                            return <span >{getGradeNumberByText(props.original.grade)}</span>
                                        }
                                    },
                                    { Header: "Total Orders", width: 150, accessor: "total" }]}
                                    defaultPageSize={10}
                                    className="-striped -highlight rtTable-Order"
                                    noDataText='No data found'
                                    showPagination={false}
                                />
                            </div>
                        </div>
                    </div>
                </div></div> 
                : 
                <div>
                {showBy == 'Daily' ? <div style={{display:'inline-block', backgroundColor: 'white',padding:'1px', margin: '5px', float: 'right', borderRadius: '3px'}}>
                    <PrintLabels {...this} grade={this.state.dayGrade||'All'} schoolYear={sessionStorage.getItem('schoolYearValue')} 
                    selectedDate={moment(this.state.pdfDayStartDate).format('YYYY-MM-DD')} showErrorMessage={(message)=>{
                        _addNotificationError(message,self);
                    }}
                    schoolId={sessionStorage.getItem('SchoolId')} />
                </div>:null}
                        <div style={{ display: 'inline-block', backgroundColor: 'white', margin: '5px', float: 'right', borderRadius: '3px' }}>
                            <a style={{ fontSize: '22px', margin: '5px' }} title="Click to Download PDF"
                                onClick={() =>(showBy == 'Daily')?this.setDayPdf(): this.setWeekPdf()}
                                target='_blank'
                                className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a></div>
                        <div className="panel panel-p1 panel-primary">
                            <div className="panel-heading text-center">
                                <h3 className="panel-title">Orders</h3>
                            </div>
                            <div className="col-xs-4" style={{ padding: '10px' }}>
                                <lable style={{
                                    padding: '20px 0px 0px 20px',
                                    fontWeight: '700',
                                }}>{showBy} Orders Report </lable>
                            </div>
                            <div className="col-xs-4" style={{ textAlign: 'center', padding: '10px' }}>
                                {showBy == 'Daily' ? <CalenderCarousel type={"Day"} date={date}
                                    startDate={startDate} endDate={endDate}
                                    dateChange={({ start, end, cDate }) => {
                                        let _start = moment(start);
                                        let _end = moment(end);
                                        this.setState({ startDate: start, endDate: end, date: cDate , showBy:'Daily',
                                        pdfDayStartDate: moment(start),pdfDayEndDate: moment(end) }, () => {
                                            this.getSchoolMealReport(_start, _end,'Day');
                                        })
                                    }} /> : <CalenderCarousel type={"Week"} date={date}
                                        startDate={wStartDate} endDate={wEndDate}
                                        dateChange={({ start, end, cDate }) => {
                                            let _start = moment(start);
                                            let _end = moment(end);
                                            this.setState({ wStartDate: start, wEndDate: end, showBy:'week', 
                                            date: cDate,pdfWeekStartDate:moment(start),pdfWeekEndDate:moment(end) }, () => {
                                                this.getSchoolMealReport(_start, _end,'week');
                                            })
                                        }} />}
                            </div>
                            <div className="col-xs-4">
                                <div style={{ padding: '10px' }}>
                                    <label>Grades</label>
                                    {showBy == 'Daily' ? <select className="dropdown" style={{ padding: '5px', marginLeft: '20px', height: '32px', fontSize: 14, textTransform: 'capitalize' }} id={"selectBy"} value={grade}
                                        onChange={(e) => this.setState({ dayGrade: e.target.value })}>
                                        <option value={"All"}>All</option>
                                        {this.state.orderStudentWithMealDay.filter(function ({ grade }) {
                                            return !this[grade] && (this[grade] = grade)
                                        }, {}).sort(function (a, b) { return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0); }).sort(function (x, y) { return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }).map((value, key) => {
                                            return(<option key={key} value={value.grade}>{getGradeNumberByText(value.grade)}</option>)
                                        })
                                        }
                                    </select> : <select className="dropdown" style={{ padding: '5px', marginLeft: '20px', height: '32px', fontSize: 14, textTransform: 'capitalize' }} id={"selectBy"} value={grade}
                                        onChange={(e) => this.setState({ weekGrade: e.target.value })}>
                                            <option value={"All"}>All</option>
                                            {this.state.orderStudentWithMealWeek.filter(function ({ grade }) {
                                                return !this[grade] && (this[grade] = grade)
                                            }, {}).sort(function (a, b) { return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0); }).sort(function (x, y) { return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }).map((value, key) => {
                                                return (<option key={key} value={value.grade}>{getGradeNumberByText(value.grade)}</option>)
                                            })
                                            }
                                        </select>}
                                   {/*  {showBy == 'Daily' ?<select className="dropdown" style={{ padding: '5px', marginLeft: '20px', height: '32px', fontSize: 14, textTransform:'capitalize' }} id={"selectBy"} value={grade}
                                        onChange={(e) => this.setState({ dayGrade: e.target.value })}>
                                        <option value={"All"}>All</option>
                                        {this.getTableData((this.state.orderStudentWithMealDay).sort(function(a,b) {return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0);}).sort(function(x,y){ return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }) ).map((value,key)=>{
                                           <option key={key} value={value.grade}>{getGradeNumberByText(value.grade)}</option> 
                                        })
                                        }
                                    </select>:<select className="dropdown" style={{ padding: '5px', marginLeft: '20px', height: '32px', fontSize: 14, textTransform:'capitalize' }} id={"selectBy"} value={grade}
                                        onChange={(e) => this.setState({ weekGrade: e.target.value })}>
                                        <option value={"All"}>All</option>
                                        {this.getTableData((this.state.orderStudentWithMealWeek).sort(function(a,b) {return (getGradeNumberByText(a.grade) > getGradeNumberByText(b.grade)) ? 1 : ((getGradeNumberByText(b.grade) > getGradeNumberByText(a.grade)) ? -1 : 0);}).sort(function(x,y){ return getGradeNumberByText(x.grade) == 'k' ? -1 : getGradeNumberByText(y.grade) == 'k' ? 1 : 0; }) ).map((value,key)=>{
                                        return (<option key={key} value={value.grade}>{getGradeNumberByText(value.grade)}</option>)                                        })
                                        }
                                    </select>} */}
                                    {showBy == 'Daily' ? 
                                        <button class="pull-right btn bg-color-4" onClick={() => { 
                                            this.setDay();
                                            this.setState({ showDashboard: true,dayGrade:'All'},); 
                                        }} style={{ margin: '0px 10px 10px 0px', color: "white" }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>:
                                        <button class="pull-right btn bg-color-4" onClick={() => { 
                                            this.setWeek();
                                            this.setState({ showDashboard: true,weekGrade:'All' });
                                     }} style={{ margin: '0px 10px 10px 0px', color: "white" }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                                    }
                                </div>
                            </div>
                            <div>
                                {showBy == 'Daily' ? <ReactTable style={{ textAlign: 'center' }}
                                    data={(this.state.dayGrade === "All") ? this.state.orderStudentWithMealDay : this.state.orderStudentWithMealDay.filter(item => item.grade === this.state.dayGrade)}
                                    columns={[{ Header: "Student Name", width: 150, accessor: "studentFName", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
                                    {
                                        Header: "Grade",style: { textAlign: 'center', textTransform:'capitalize' }, Cell: (props) => {
                                            return <span>{getGradeNumberByText(props.original.grade)}</span>
                                        }
                                    },
                                    { Header: "Teacher", accessor: "teacherName" },
                                    { Header: "Items Name", Cell: props => <span>{(props.original.mealOrderedByDate[this.state.orderResponse] || '').toString()}</span> },
                                    { Header: "Sides", Cell: props => <span>{this.getSidesVal(props)}</span> },
                                    { Header: "Allergies", Cell: props => <span>{(props.original.allergies || '') === '' ? 'No Allergies' : props.original.allergies}</span> },
                                    { Header: "Served", accessor: "served" }]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    noDataText='No data found'
                                    showPagination={true}
                                /> : this.bindWeekDataTable()
                                }
                            </div></div>
                    </div>}
            </div>
        );
    }
}

export default SnackOrderReport;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/Orders/snackOrderReport.jsx